<div class="main-container" [ngStyle]="{'visibility' : alertData.show ? 'visible' : 'hidden'}">

  <div class="alert-container" [ngClass]="{'zoomIn': alertData.show}">

    <div class="alert-header">
      <ion-button *ngIf="alertData.closeButton"
                  fill="clear"
                  (click)="close()"
                  [strong]="true">
        <ion-icon slot="icon-only" color="dark" name="close"></ion-icon>
      </ion-button>
    </div>

    <div class="alert-body">
      <ion-icon [name]="alertData.icon"
                [color]="alertData.iconColor"
                [class]="alertData.status"></ion-icon>

      <ion-text class="ion-text-center">
        <h1 *ngIf="alertData.title && alertData.title !== ''">{{ alertData.title | translate }}</h1>
        <br *ngIf="alertData.title && alertData.title === ''">
        <p *ngIf="alertData.text && alertData.text !== '' && alertData.textFormat !== 'html'">{{ alertData.text | translate }}</p>
        <p *ngIf="alertData.text && alertData.text !== '' && alertData.textFormat === 'html'" [innerHTML]="alertData.text | translate"></p>
      </ion-text>

      <!--<mobile-form-input-code *ngIf="alertData.component && alertData.component === 'code'"
                             (codeChanged)="componentInputs.code=$event"></mobile-form-input-code>-->

      <div class="buttons">
        <ion-button *ngFor="let button of alertData.buttons!"
                    [color]="button.color"
                    [fill]="button.fill"
                    (click)="clickButton(button)"
                    bind-attr.role="button.closeButton? 'close' : ''">
          {{ button.text | translate }}
        </ion-button>
      </div>

    </div>
  </div>
</div>
